var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#444d63",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3 10.75c-.2.599-.3 1.297-.3 1.995M18 12.745c0-3.29-2.7-5.983-6-5.983-.7 0-1.4.1-2 .299"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    transform: "translate(1 1.776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.6 9.573L6 5.983"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10.97,
    rx: 2,
    ry: 1.994
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 10.97,
    rx: 11,
    ry: 10.97
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f2008d62.svg";
export { ForwardRef as ReactComponent };